(function () {
  const HASH_TO_TAB = {
    'product-anchor-gallery': 'gallery',
    'product-anchor-parameters': 'params',
    'product-equipment-main': 'equipment',
    'product-anchor-about': 'about',
    'product-anchor-reviews': 'reviews',
    'product-anchor-related-products': 'related',
  };

  /** --header-height pro `top` u sticky záložek (soulad s výškou header group v theme). */
  function syncHeaderHeightToCssVar() {
    const hg = document.querySelector('.shopify-section-group-header-group');
    if (hg && hg.offsetHeight > 8) {
      document.documentElement.style.setProperty('--header-height', `${hg.offsetHeight}px`);
      return;
    }
    const hw = document.querySelector('.header-wrapper');
    if (hw && hw.offsetHeight > 8) {
      document.documentElement.style.setProperty('--header-height', `${hw.offsetHeight}px`);
    }
  }

  function startHeaderHeightSync() {
    syncHeaderHeightToCssVar();
    window.addEventListener('resize', syncHeaderHeightToCssVar, { passive: true });

    const hg = document.querySelector('.shopify-section-group-header-group');
    if (hg && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => syncHeaderHeightToCssVar());
      ro.observe(hg);
    }

    let frames = 0;
    function rafTick() {
      syncHeaderHeightToCssVar();
      if (++frames < 12) requestAnimationFrame(rafTick);
    }
    requestAnimationFrame(rafTick);
  }

  function resolveInitialTabKey(links) {
    const hashId = window.location.hash.replace(/^#/, '');
    if (hashId && HASH_TO_TAB[hashId]) {
      const k = HASH_TO_TAB[hashId];
      if (links.some((l) => l.getAttribute('data-tab-key') === k)) {
        return k;
      }
    }
    let fromUrl = new URLSearchParams(window.location.search).get('tab');
    if (fromUrl === 'intro') {
      fromUrl = null;
    }
    if (fromUrl && links.some((l) => l.getAttribute('data-tab-key') === fromUrl)) {
      return fromUrl;
    }
    return 'all';
  }

  function getMainFlexLayoutItems(main) {
    const items = [];
    for (const child of main.children) {
      let cs;
      try {
        cs = window.getComputedStyle(child);
      } catch (e) {
        cs = null;
      }
      if (!cs || cs.display === 'none') continue;
      if (cs.display === 'contents') {
        for (const sub of child.children) {
          let subCs;
          try {
            subCs = window.getComputedStyle(sub);
          } catch (e) {
            subCs = null;
          }
          if (!subCs || subCs.display === 'none') continue;
          items.push(sub);
        }
      } else {
        items.push(child);
      }
    }
    return items;
  }

  function pinTabsNavFlexOrder(main) {
    const section = main.querySelector('.shopify-section.product-tabs-nav-section');
    const wrap = main.querySelector('.product-tabs-nav-wrapper');
    if (!section || !wrap) return;
    const order =
      wrap.dataset.flexOrderBase || section.dataset.flexOrderBase || wrap.style.order || section.style.order;
    if (!order) return;
    section.style.order = order;
    wrap.style.order = order;
    section.dataset.flexOrderBase = order;
    wrap.dataset.flexOrderBase = order;
  }

  function ensureMainFlexBaseOrders(main) {
    if (main.dataset.aboutRelatedFlexInited === '1') {
      pinTabsNavFlexOrder(main);
      return;
    }
    main.dataset.aboutRelatedFlexInited = '1';
    const items = getMainFlexLayoutItems(main);
    items.forEach((el, i) => {
      const base = i * 10;
      el.dataset.flexOrderBase = String(base);
      el.style.order = String(base);
    });
    pinTabsNavFlexOrder(main);
  }

  function syncProductTabSectionOrder(tabKey) {
    if (!document.body.classList.contains('template-product')) return;
    const main = document.getElementById('MainContent');
    const aboutMarker = document.querySelector('[data-product-tab-order-marker="about-section"]');
    const relatedMarker = document.querySelector('[data-product-tab-order-marker="related-podobne"]');
    if (!main || !aboutMarker || !relatedMarker) return;
    const aboutSec = aboutMarker.closest('.shopify-section');
    const relatedSec = relatedMarker.closest('.shopify-section');
    if (!aboutSec || !relatedSec || aboutSec === relatedSec) return;

    const reviewsMarker = document.querySelector('[data-product-tab-order-marker="reviews-section"]');
    const reviewsSec = reviewsMarker ? reviewsMarker.closest('.shopify-section') : null;

    ensureMainFlexBaseOrders(main);
    const aboutBase = parseInt(aboutSec.dataset.flexOrderBase, 10);
    const relatedBase = parseInt(relatedSec.dataset.flexOrderBase, 10);
    const reviewsBase = reviewsSec ? parseInt(reviewsSec.dataset.flexOrderBase, 10) : NaN;

    if (!Number.isNaN(aboutBase)) aboutSec.style.order = String(aboutBase);
    if (!Number.isNaN(relatedBase)) relatedSec.style.order = String(relatedBase);
    if (reviewsSec && !Number.isNaN(reviewsBase)) reviewsSec.style.order = String(reviewsBase);

    if (tabKey === 'about' && !Number.isNaN(aboutBase) && !Number.isNaN(relatedBase)) {
      const lo = Math.min(aboutBase, relatedBase);
      const hi = Math.max(aboutBase, relatedBase);
      aboutSec.style.order = String(lo);
      relatedSec.style.order = String(hi);
    } else if (tabKey === 'reviews' && reviewsSec && !Number.isNaN(reviewsBase) && !Number.isNaN(relatedBase)) {
      const lo = Math.min(reviewsBase, relatedBase);
      const hi = Math.max(reviewsBase, relatedBase);
      reviewsSec.style.order = String(lo);
      relatedSec.style.order = String(hi);
    }
  }

  function applyTab(tabKey, root) {
    syncProductTabSectionOrder(tabKey);

    const isAll = tabKey === 'all';
    document.body.classList.toggle('product-tab-mode-all', isAll);
    document.body.classList.toggle('product-tab-mode-single', !isAll);
    document.body.classList.toggle('product-tab-about-active', tabKey === 'about');
    document.body.classList.toggle('product-tab-reviews-active', tabKey === 'reviews');

    if (isAll) {
      document.querySelectorAll('.product-tab-panel--hidden').forEach((el) => {
        el.classList.remove('product-tab-panel--hidden');
      });
    } else {
      document.querySelectorAll('[data-product-tab-always]').forEach((el) => {
        el.classList.remove('product-tab-panel--hidden');
      });
      document.querySelectorAll('[data-product-tab-show]').forEach((el) => {
        if (el.hasAttribute('data-product-tab-always')) return;
        const keys = (el.getAttribute('data-product-tab-show') || '').split(/\s+/).filter(Boolean);
        const visible = keys.includes(tabKey);
        el.classList.toggle('product-tab-panel--hidden', !visible);
      });
    }
  }

  function updateTabIndicator(listEl, activeLink) {
    if (!listEl) return;
    if (!activeLink) {
      listEl.style.setProperty('--tab-indicator-width', '0px');
      return;
    }
    const lr = listEl.getBoundingClientRect();
    const ar = activeLink.getBoundingClientRect();
    listEl.style.setProperty('--tab-indicator-left', `${ar.left - lr.left}px`);
    listEl.style.setProperty('--tab-indicator-width', `${ar.width}px`);
  }

  function setActive(links, activeLink, scrollEl, listEl, alignStrip) {
    links.forEach((l) => {
      const on = l === activeLink;
      l.classList.toggle('is-active', on);
      l.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    updateTabIndicator(listEl, activeLink);
    if (!alignStrip || !activeLink || !scrollEl) return;
    const left = activeLink.offsetLeft - scrollEl.clientWidth / 2 + activeLink.clientWidth / 2;
    scrollEl.scrollTo({ left: Math.max(0, left), top: 0 });
  }

  function getLinkTargetSelector(link) {
    let sel = link.getAttribute('data-target');
    if (!sel) {
      const href = (link.getAttribute('href') || '').trim();
      if (href.startsWith('#') && href.length > 1) sel = href;
    }
    return sel && sel !== '#' ? sel : null;
  }

  /** Jen scroll ke kotvě (scroll-margin na kotvách řeší header + lištu). */
  function scrollToTabTarget(link) {
    const sel = getLinkTargetSelector(link);
    if (!sel) return;
    const el = document.querySelector(sel);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function buildScrollSpyEntries(links) {
    const entries = [];
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const key = link.getAttribute('data-tab-key');
      if (key === 'all') continue;
      let sel = link.getAttribute('data-target');
      if (!sel) {
        const href = (link.getAttribute('href') || '').trim();
        if (href.startsWith('#') && href.length > 1) sel = href;
      }
      if (!sel || sel === '#') continue;
      const el = document.querySelector(sel);
      if (el) entries.push({ key: key, el: el, link: link });
    }
    entries.sort(function (a, b) {
      return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
    });
    return entries;
  }

  /** Seřadí kotvy podle aktuální pozice na obrazovce (offsetTop u vnořených kotev klamal). */
  function sortSpyEntriesVisual(entries) {
    return entries
      .filter(function (e) {
        return e.el && e.el.isConnected;
      })
      .slice()
      .sort(function (a, b) {
        return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
      });
  }

  /** Převod délky z getComputedStyle (např. 12.5px) na číslo px. */
  function parseCssPx(value) {
    const v = parseFloat(String(value || '').trim());
    return Number.isFinite(v) ? v : 0;
  }

  /** Sekce se přepne, jakmile její začátek najede ~100px do stránky, ne až u horní lišty. */
  function getScrollSpyLineY() {
    return Math.max(0, window.innerHeight - 100);
  }

  function initRoot(root) {
    if (!root || root.dataset.productTabsNavInit === '1') return;
    root.dataset.productTabsNavInit = '1';

    if (root._productTabsSpyAbort) {
      root._productTabsSpyAbort.abort();
      root._productTabsSpyAbort = null;
    }

    const links = Array.from(root.querySelectorAll('[data-tabs-link]'));
    const scrollEl = root.querySelector('[data-tabs-scroll]');
    const listEl = scrollEl ? scrollEl.querySelector('.product-tabs-nav__list') : null;
    if (!links.length) return;

    if (scrollEl) {
      scrollEl.addEventListener(
        'scroll',
        () => {
          if (scrollEl.scrollTop) scrollEl.scrollTop = 0;
        },
        { passive: true },
      );
    }

    const navWrapper = root.closest('.product-tabs-nav-wrapper');

    /** Lišta drží jen do konce recenzí, pak odjede nahoru. */
    function releaseTabsAfterReviews() {
      if (!navWrapper || !navWrapper.classList.contains('product-tabs-nav-wrapper--sticky')) return;
      const reviews = document.getElementById('product-anchor-reviews');
      if (!reviews) {
        navWrapper.style.top = '';
        return;
      }
      const headerH = parseCssPx(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
      const stickTop = Math.max(0, headerH - 1);
      const released = navWrapper.classList.contains('is-released');
      const limit = stickTop + navWrapper.offsetHeight + (released ? 24 : 0);
      const reviewsBottom = reviews.getBoundingClientRect().bottom;
      navWrapper.classList.toggle('is-released', reviewsBottom < limit);
      navWrapper.style.top = '';
    }

    /** Během smooth scrollu po kliku spy nesmí přepsat aktivní bublinu (jinak „skáče“ na jinou). */
    let mobileSpyPaused = false;
    let mobileSpyPauseTimer = 0;
    let pinnedScrollY = null;
    function pauseMobileScrollSpyForNavigation() {
      window.clearTimeout(mobileSpyPauseTimer);
      if (root._mobileSpyResumeFn) {
        window.removeEventListener('scrollend', root._mobileSpyResumeFn);
        root._mobileSpyResumeFn = null;
      }
      mobileSpyPaused = true;
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        window.removeEventListener('scrollend', finish);
        window.clearTimeout(mobileSpyPauseTimer);
        root._mobileSpyResumeFn = null;
        mobileSpyPaused = false;
        pinnedScrollY = window.scrollY;
      };
      root._mobileSpyResumeFn = finish;
      window.addEventListener('scrollend', finish, { passive: true });
      mobileSpyPauseTimer = window.setTimeout(finish, 2500);
    }

    let scrollSpyRaf = 0;
    function runScrollSpy() {
      if (mobileSpyPaused) return;
      if (pinnedScrollY != null && Math.abs(window.scrollY - pinnedScrollY) < 48) return;
      pinnedScrollY = null;
      if (!document.body.classList.contains('product-tab-mode-all')) return;
      const spyEntries = buildScrollSpyEntries(links);
      if (!spyEntries.length) return;
      const line = getScrollSpyLineY();
      const sorted = sortSpyEntriesVisual(spyEntries);
      let active = sorted[0].link;
      for (let i = 0; i < sorted.length; i++) {
        if (sorted[i].el.getBoundingClientRect().top <= line) active = sorted[i].link;
      }
      const current = links.find((l) => l.classList.contains('is-active'));
      if (current !== active) setActive(links, active, scrollEl, listEl, true);
    }

    function onScrollSpyTick() {
      scrollSpyRaf = 0;
      releaseTabsAfterReviews();
      runScrollSpy();
    }

    function requestScrollSpy() {
      if (scrollSpyRaf) return;
      scrollSpyRaf = window.requestAnimationFrame(onScrollSpyTick);
    }

    const spyAbort = new AbortController();
    root._productTabsSpyAbort = spyAbort;

    function scheduleIndicatorUpdate() {
      const act = links.find((l) => l.classList.contains('is-active'));
      requestAnimationFrame(() => updateTabIndicator(listEl, act || null));
    }

    function onWinResize() {
      scheduleIndicatorUpdate();
      if (document.body.classList.contains('product-tab-mode-single')) {
        applyTab('all', root);
        requestAnimationFrame(runScrollSpy);
      }
      requestScrollSpy();
    }

    window.addEventListener('scroll', requestScrollSpy, { passive: true, signal: spyAbort.signal });
    window.addEventListener('resize', onWinResize, { passive: true, signal: spyAbort.signal });

    if (listEl && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        scheduleIndicatorUpdate();
        requestScrollSpy();
      });
      ro.observe(listEl);
    }

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const tabKey = link.getAttribute('data-tab-key');
        if (!tabKey) return;
        applyTab('all', root);
        setActive(links, link, scrollEl, listEl, true);
        if (tabKey !== 'all') {
          pauseMobileScrollSpyForNavigation();
          scrollToTabTarget(link);
        } else {
          requestAnimationFrame(runScrollSpy);
        }
      });
    });

    const initial = resolveInitialTabKey(links);
    applyTab('all', root);
    const spyEntries = buildScrollSpyEntries(links);
    const firstSpyLink = spyEntries.length ? spyEntries[0].link : null;
    let activeLink =
      initial === 'all'
        ? firstSpyLink || links.find((l) => l.getAttribute('data-tab-key') !== 'all') || links[0] || null
        : links.find((l) => l.getAttribute('data-tab-key') === initial) || firstSpyLink || links[0] || null;
    if (activeLink) {
      setActive(links, activeLink, scrollEl, listEl, true);
      requestAnimationFrame(scheduleIndicatorUpdate);
      if (initial !== 'all') {
        requestAnimationFrame(() => {
          pauseMobileScrollSpyForNavigation();
          scrollToTabTarget(activeLink);
        });
      } else {
        requestAnimationFrame(runScrollSpy);
      }
    } else {
      requestAnimationFrame(runScrollSpy);
    }
    releaseTabsAfterReviews();
  }

  function initAll() {
    syncHeaderHeightToCssVar();
    document.querySelectorAll('[data-product-tabs-root]').forEach(initRoot);
  }

  function boot() {
    startHeaderHeightSync();
    const main = document.getElementById('MainContent');
    if (main) pinTabsNavFlexOrder(main);
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncHeaderHeightToCssVar();
    const root = event.target.querySelector && event.target.querySelector('[data-product-tabs-root]');
    if (root) {
      root.dataset.productTabsNavInit = '0';
      initRoot(root);
    } else {
      initAll();
    }
  });
})();
